































































import { Vue, Component, Prop } from 'vue-property-decorator'
import TooltipMeta from '../../components/misc/TooltipMeta.vue'

@Component({
    components: {
        TooltipMeta,
    },
})
export default class ContentMetadata extends Vue {
    @Prop() totalBlockchains!: number
    @Prop() totalValidators!: number
    @Prop() totalDelegators!: number
    @Prop() totalControlKeys!: number
}
